import {Map, List} from 'immutable';

import * as actions from './actions';
import '../libraries';

export default (state = new Map(), action) => {
    if (!state.get('elementId'))
        state = state.set('elementId', window.uuidv4());
    if (state.get('activePath') === undefined) {
        state = state.set('activePath', new List());
    }
    if (state.get('items') === undefined) {
        state = state.set('items', new List());
    }
    if (state.get('path') === undefined) {
        state = state.set('path', new List());
    }
    if (action.elementId === state.get('elementId')) {
        switch (action.type) {
        case actions.SET_ACTIVE_PATH:
            state = state.set('activePath', action.activePath);
            break;

        case actions.SET_ITEMS:
            state = state.set('items', action.items);
            break;

        case actions.SHOW_MENU:
            state = state.set('manualActivePath', action.path);
            break;

        case actions.HIDE_MENU:
            state = state.delete('manualActivePath');
            break;
        }
    }
    return state;
};
